<template>
  <div class="d-flex">
    <div
      v-if="catalogDetails.productCategory === 'Catering'"
      class="h-100 sub-catalog-sidebar"
    >
      <div class="py-2">
        <div class="font-weight-bold mb-2">
          <i class="fa-regular fa-calendar-range mr-2" />
          {{ $t('shop.deliveryPlan.menu') }}
        </div>
        <div class="pl-2">
          <div
            v-for="p in menuNodes"
            :key="p.id"
            class="menu-node"
            :class="{ selected: menuNodeId === p.nodeId && view === 'menu' }"
            @click="menuNodeId = p.nodeId; view = 'menu'"
          >
            {{ p.name }}
          </div>
        </div>
      </div>

      <hr>
      <div
        class="menu-node"
        :class="{ selected: view === 'meals' }"
        @click="view = 'meals'"
      >
        <i class="fa-regular fa-pot-food mr-1" />
        {{ $t('shop.deliveryPlan.meals') }}
      </div>
      <div
        class="menu-node"
        :class="{ selected: view === 'ingredients' }"
        @click="view = 'ingredients'"
      >
        <i class="fa-regular fa-carrot mr-1" />
        {{ $t('shop.deliveryPlan.ingredients') }}
      </div>
    </div>
    <div
      v-else
      class="h-100 sub-catalog-sidebar mx-0"
    >
      <div class="px-2 d-flex pb-2">
        <div
          class="menu-node w-50 text-center mx-2"
          :class="{ selected: eventsView === 'events' }"
          @click="eventsView = 'events'"
        >
          <i class="far fa-calendar mr-1" />
          Wydarzenia
        </div>
        <div
          class="menu-node w-50 text-center mx-2"
          :class="{ selected: eventsView === 'rules' }"
          @click="eventsView = 'rules'"
        >
          <i class="far fa-gears mr-1" />
          Reguły
        </div>
      </div>
      <SubCatalogsSidebar
        :catalog="catalogDetails"
        :selected.sync="selected"
        class="text-left"
        style="margin-right: 0!important; margin-left: 0!important;"
        select-only
      />
    </div>

    <div
      class="flex-grow-1 content"
    >
      <div v-if="catalogDetails.productCategory === 'Courses'">
        <EventsCalendar
          v-if="eventsView === 'events'"
          :catalog-id="catalogId"
          :node-ids="selected"
          :move-direction="move"
        />
        <CalendarRules
          v-if="eventsView === 'rules'"
          :catalog-id="catalogId"
          :node-ids="selected"
        />
      </div>
      <div
        v-else-if="view === 'menu' && menuNodeId"
        class="full-height d-flex flex-column"
      >
        <DeliveryPlanCalendar
          :menu-node-id="menuNodeId"
          :catalog-id="catalogId"
          :move-direction="move"
        />
      </div>
      <Ingredients
        v-else-if="view === 'ingredients'"
        :catalog-id="catalogId"
      />
      <Meals
        v-else-if="view === 'meals'"
        :catalog-id="catalogId"
      />
    </div>
  </div>
</template>

<script>
import CalendarRules from '@/components/shop/CalendarRules';
import DeliveryPlanCalendar from '@/components/shop/DeliveryPlanCalendar';
import EventsCalendar from '@/components/shop/EventsCalendar';
import { mapActions, mapGetters } from 'vuex';
import SubCatalogsSidebar from './catalogs/SubCatalogsSidebar';
import Ingredients from './delivery/Ingredients';
import Meals from './delivery/Meals';

export default {
  props: {
    catalogId: String,
  },
  data: () => ({
    modal: false,
    edited: null,
    menuNodeId: null,
    deliveryPlans: [],
    move: '',
    view: 'menu',
    eventsView: 'rules',
    selected: [],
  }),
  components: {
    Meals,
    Ingredients,
    DeliveryPlanCalendar,
    EventsCalendar,
    CalendarRules,
    SubCatalogsSidebar,
  },
  computed: {
    ...mapGetters('shop', [
      'catalogDetails',
    ]),
    menuNodes() {
      const { menuId } = this.catalogDetails.metadata;
      if (!menuId) {
        return [];
      }

      return this.catalogDetails.subCatalogNodes.filter((x) => x.subCatalogId === menuId);
    },
  },
  methods: {
    ...mapActions('shop', [
      'getCatalogListings',
    ]),
  },
  created() {
    this.getCatalogListings({
      params: {
        catalogId: this.catalogId,
      },
    });

    if (this.menuNodes.length > 0) {
      this.menuNodeId = this.menuNodes[0].nodeId;
    }

    this.$emit('page', 'calendar');
  },
};
</script>

<style lang="scss" scoped>
.sub-catalog-sidebar {
  width: 300px;
  overflow: auto;
  margin-left: 10px;
  margin-right: 10px;
  height: calc(100vh - 240px);
}

.selectable {
  display: block;
  cursor: pointer;

  &:hover {
    background-color: rgba($blue, 0.5);
  }
}

.menu-node {
  padding: 5px 10px;
  background-color: #fbfbfb;
  margin-top: 5px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  border-radius: 5px;

  &:hover {
    background-color: #ebebeb;
  }

  &.selected {
    background-color: rgba($blue, 0.1);
  }
}

.content {
  border-left: 1px solid rgb(239, 239, 239);
  min-width: 0;
  flex-basis: min-content;
}

.full-height {
  height: calc(100vh - 270px);
}
</style>
